import EventDetailsHeader, { Component } from './EventDetailsHeader';

export default EventDetailsHeader;
export { Component };
